import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalClose,
  Box,
  Grid,
  Input,
  Text,
  Spacer,
  Notify
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { useFormik } from 'formik';
import urls from 'utils/config';
import request from 'utils/request';
import Theme from 'utils/theme';
import * as Yup from 'yup';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

const validationSchema = Yup.object().shape({
  username: Yup.string().required('Enter Email Address'),
});

export default function ResetpasswordModal({ isOpen, close }) {
  const { params } = useRouteMatch();
  const [successView, setSuccessView] = useState(false);
  const [resetting, setResetting] = useState(false);
  const formik = useFormik({
    initialValues: {
      username: '',
    },
    validationSchema: validationSchema,
    validateOnMount: false,
    onSubmit: (values) => {
      requestResetPassword({ ...values, organisation: params.orgName }, () => {
        formik.setValues(formik.initialValues);
        setSuccessView(true);
      }
      );
    },
  });

  const requestResetPassword = async (value, callBack) => {
    const url = `${API_BASE_URL}/ums/password/reset-request`;
    const data = value;
    setResetting(true);
    try {
      const response = await request({ method: 'post', data, url });
      if (response.success) {
        Notify(
          'Password reset submitted successfully, Please check your mail',
          { status: 'success' }
        );
        callBack();
      }else{
        networkErrorHandler(response?.statusCode, response?.message);
      }
    } catch (error) {
      Notify('Unable to reset password', { status: 'error' });
    } finally {
      setResetting(false);
    }
  };

  useEffect(() => {
    setSuccessView(false);
  }, [isOpen]);

  return (
    <div>
      <Modal
        overlayOpacity={0.7}
        outerclick
        onClose={close}
        open={isOpen}
        center={true}
      >
        <ModalBody width="500px">
          <ModalClose onClick={close}>&times;</ModalClose>
          <Box pad="2rem">
            <h2>Reset Password</h2>
            {successView ? (
              <Box pad="2rem 0 5rem">
                <Text>
                  Your email reset has been sent to your email
                </Text>
              </Box>
            ) : (
              <React.Fragment>
                <Box pad="2rem 0 3rem">
                  <Text>
                    You are about to reset your password, please enter your
                    email address on your account to continue or cancel to go
                    back. 
                  </Text>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                  <Grid default="1fr">
                    <Input
                      label="Email Address"
                      name="username"
                      id="username"
                      height="50px"
                      value={formik.values.username}
                      onChange={formik.handleChange}
                      error={formik.errors.username}
                      required
                      placeholder="email address"
                    />
                    <Spacer space="10px" />
                    <Grid default="150px 1fr 1fr">
                      <Text />
                      <Button
                        height={50}
                        color={Theme.PrimaryRed}
                        fontColor={Theme.PrimaryRed}
                        pale
                        onClick={close}
                      >
                        cancel
                      </Button>
                      <Button
                        height={50}
                        progress={resetting}
                        onClick={formik.handleSubmit}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </React.Fragment>
            )}
          </Box>
        </ModalBody>
      </Modal>
    </div>
  );
}

ResetpasswordModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};
